<template>
  <page>
    <page-poster-with-image
      :headline="$t('targeting.headline')"
      src="/img/posters/targetingPoster.png"
      :alt="$t('red.button')"
    />
    <div class="container">
      <targeting-section :paragraph="$t('targeting.section-1.paragraph')" />
      <targeting-section
        :headline="$t('targeting.section-2.headline')"
        :paragraph="$t('targeting.section-2.paragraph')"
        src="/img/targeting/woodenLittleMen.png"
        :alt="$t('wooden.little.men')"
        :class="$style['section-1']"
      />
      <targeting-section
        :headline="$t('targeting.section-3.headline')"
        :paragraph="$t('targeting.section-3.paragraph')"
        src="/img/targeting/fightFlightShark.png"
        :alt="$t('fight.flight.shark')"
        :class="$style['section-2']"
      />
      <targeting-section
        :headline="$t('targeting.section-4.headline')"
        :paragraph="$t('targeting.section-4.paragraph')"
      />
      <targeting-section
        :headline="$t('targeting.section-5.headline')"
        :paragraph="$t('targeting.section-5.paragraph')"
        src="/img/targeting/manWithPaintedBiceps.png"
        :alt="$t('biceps.man')"
        :class="$style['section-5']"
      />
    </div>
    <page-info-footer-row />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePosterWithImage from '@/components/common/PagePosterWithImage.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import TargetingSection from '@/components/targeting/TargetingSection.vue';

export default {
  components: {
    Page,
    PagePosterWithImage,
    PageInfoFooterRow,
    TargetingSection,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.container {
  max-width: 865px;
  padding: 0 25px;
}

@media (max-width: $page-table-breakpoint) {
  .container {
    max-width: $page-mobile-large-breakpoint;
  }
}
</style>
<style lang="scss" module>
@import '~@/assets/styles/variables';

.section-1 {
  display: flex;
  flex-direction: row-reverse;

  img {
    height: 310px;
    margin-right: 40px;
  }
}

.section-2 {
  img {
    max-width: 100%;
    margin-top: 40px;
  }
}

.section-5 {
  display: flex;
  padding-bottom: 40px;

  img {
    height: 350px;
    margin-left: 40px;
  }
}
</style>
